module.exports = __webpack_public_path__ + "static/Logo-tmn-cbaca265e490a612f602d9c83d0c9e30.png";